import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/youtube-scheduler")({
	beforeLoad: () => {
		throw redirect({ to: "/channels/youtube" });
	},
});
